/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Focus_TitleInputs */

const en_lg_focus_title = /** @type {(inputs: Lg_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your focus and sound`)
};

const id_lg_focus_title = /** @type {(inputs: Lg_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus dan suara sesuai pilihanmu`)
};

/**
* | output |
* | --- |
* | "Choose your focus and sound" |
*
* @param {Lg_Focus_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_focus_title = /** @type {((inputs?: Lg_Focus_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Focus_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_focus_title(inputs)
	return en_lg_focus_title(inputs)
});